export function formatNumberWithCommas(value: string | undefined) {
  if (typeof value === 'string') {
    const parsedNumber = parseFloat(value);
    if (!isNaN(parsedNumber)) {
      return parsedNumber.toLocaleString();
    }
  }
  return value;
}